/**
 * Intake checklist state for the open referral panel (2026-10-22 fix).
 *
 * The panel shows `{...referral.intake_status, ...taskOverlay}`. The
 * optimistic overlay is dropped once the list poll confirms a step, so from
 * then on the panel's OWN copy of `intake_status` has to say the step is
 * done. Two things used to break that:
 *
 *   1. The detail payload (`GET /api/intake/referrals/{id}`, and the
 *      `/card` endpoint's `detail`) carries `intake_status: {is_cancelled}`
 *      only. Spreading it over the panel's referral REPLACED the whole
 *      `intake_status`, dropping billing_complete / payor_complete /
 *      ready_for_crm.
 *   2. List polls never refreshed the open panel's copy; they only kept or
 *      closed it.
 *
 * So when a poll confirmed Billing and dropped the overlay, the box
 * unticked and Ready locked (PI: about 9 Billing clicks per referral on
 * Oct 22, once the pending cache refreshed on time).
 *
 * `mergeDetail` keeps every checklist key the panel already has and lets the
 * detail add or change only the keys it actually carries. `refreshFromRow`
 * takes the list row's computed checklist (the server's truth, with any
 * pending optimistic fields already merged in by the poll).
 */

export function mergeDetail(current, detail) {
  if (!current) return current;
  if (!detail) return current;
  return {
    ...current,
    ...detail,
    intake_status: {
      ...(current.intake_status || {}),
      ...(detail.intake_status || {}),
    },
  };
}

export function refreshFromRow(current, row) {
  if (!current || !row) return current;
  if (!row.intake_status) return current;
  return {
    ...current,
    intake_status: {
      ...(current.intake_status || {}),
      ...row.intake_status,
    },
  };
}
